import { api, TOKEN_KEY } from "./api";
import { adaptList } from "@/lib/adapters";

const setToken = (t) => {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch (_) {}
};

export const authService = {
  me: () => api.get("/auth/me"),
  session: async () => (await api.get("/auth/session")).user,
  async login(email, password) {
    const r = await api.post("/auth/login", { email, password });
    setToken(r.token);
    return r.user;
  },
  async register(name, email, password) {
    const r = await api.post("/auth/register", { name, email, password });
    setToken(r.token);
    return r.user;
  },
  async google(sessionId) {
    const r = await api.post("/auth/google/session", { session_id: sessionId });
    setToken(r.token);
    return r.user;
  },
  async logout() {
    try {
      await api.post("/auth/logout");
    } finally {
      setToken(null);
    }
  },
  updateProfile: (data) => api.patch("/auth/me", data),
};

export const watchlistService = {
  list: async () => adaptList((await api.get("/watchlist")).items),
  ids: async () => (await api.get("/watchlist/ids")).ids || [],
  add: (id) => api.post(`/watchlist/${encodeURIComponent(id)}`),
  remove: (id) => api.del(`/watchlist/${encodeURIComponent(id)}`),
};

export const progressService = {
  continueWatching: async () => adaptList((await api.get("/progress")).items),
};

export const adminService = {
  stats: () => api.get("/admin/stats"),
  list: (q = "", page = 1) => api.get("/admin/movies", { params: { q, page } }),
  get: (id) => api.get(`/admin/movies/${encodeURIComponent(id)}`),
  create: (data) => api.post("/admin/movies", data),
  update: (id, data) => api.put(`/admin/movies/${encodeURIComponent(id)}`, data),
  remove: (id) => api.del(`/admin/movies/${encodeURIComponent(id)}`),
  getSettings: () => api.get("/admin/settings"),
  saveSettings: (data) => api.put("/admin/settings", data),
  syncStatus: () => api.get("/admin/uzmovi/status"),
  syncNow: (pages = 3, deep = false) => api.post("/admin/uzmovi/sync", { pages, deep }),
  refreshOne: (id) => api.post(`/admin/uzmovi/refresh/${encodeURIComponent(id)}`),
};
